import axios from "axios";
import store from "../store";
import router from "../router";
import { Message } from "element-ui";

// 配置baseURL
// axios.defaults.baseURL = 'http://192.168.0.105:10086' // 生产环境(内网)
// axios.defaults.baseURL = 'http://192.168.11.44:10086' // 测试环境
// axios.defaults.baseURL = 'http://8.130.162.141:10086' // 生产环境
axios.defaults.baseURL = "http://1.117.24.106:10086"; // 生产环境(外网)
// axios.defaults.baseURL = "http://localhost:8080"; // 本地开发环境

// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    config.headers["Accept"] = "application/json, text/plain, */*";
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
    // config.headers["Content-Type"] =
    //   "application/x-www-form-urlencoded;charset=UTF-8";
    // 设置带token的请求头
    if (store.getters.getToken) {
      config.headers.token = store.getters.getToken;
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    Message.error(error.response.data.message);
    console.trace(error.response);
    if (error.response.data.code === 2) router.push("/login");
    // return Promise.reject(error)
  }
);

export default axios;
